import React, { useState } from 'react';
import './ChangelogPage.css';

const ChangelogPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const systemUpdates = [
    {
      id: 1,
      version: "v2.5.0",
      date: "2024-01-15",
      type: "feature",
      title: "Real-time Notifications",
      description: "Added real-time notification system for user activities",
      changes: [
        "WebSocket integration for live updates",
        "Notification center with mark as read",
        "Email notifications for important events"
      ],
      author: "Development Team"
    },
    {
      id: 2,
      version: "v2.4.3",
      date: "2024-01-10",
      type: "fix",
      title: "Bug Fixes and Performance Improvements",
      description: "Various bug fixes and system optimizations",
      changes: [
        "Fixed memory leak in dashboard component",
        "Improved database query performance",
        "Resolved UI alignment issues"
      ],
      author: "QA Team"
    },
    {
      id: 3,
      version: "v2.4.0",
      date: "2024-01-05",
      type: "feature",
      title: "Advanced Reporting Module",
      description: "New reporting features with export capabilities",
      changes: [
        "Custom report builder",
        "PDF and Excel export options",
        "Scheduled report generation"
      ],
      author: "Development Team"
    },
    {
      id: 4,
      version: "v2.3.2",
      date: "2024-01-02",
      type: "security",
      title: "Security Updates",
      description: "Important security patches and updates",
      changes: [
        "Updated authentication middleware",
        "Enhanced password policies",
        "Fixed XSS vulnerability"
      ],
      author: "Security Team"
    },
    {
      id: 5,
      version: "v2.3.0",
      date: "2023-12-28",
      type: "feature",
      title: "Mobile Responsive Design",
      description: "Complete mobile optimization",
      changes: [
        "Responsive layout for all screens",
        "Touch-friendly interface",
        "Progressive Web App features"
      ],
      author: "UI/UX Team"
    },
    {
      id: 6,
      version: "v2.2.1",
      date: "2023-12-20",
      type: "announcement",
      title: "System Maintenance",
      description: "Upcoming system maintenance schedule",
      changes: [
        "Database optimization - Jan 5, 2024 (2:00 AM - 4:00 AM)",
        "Server migration - Jan 12, 2024 (12:00 AM - 6:00 AM)"
      ],
      author: "System Admin"
    }
  ];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = systemUpdates.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(systemUpdates.length / itemsPerPage);

  const getTypeIcon = (type) => {
    switch (type) {
      case 'feature': return '🆕';
      case 'fix': return '🔧';
      case 'security': return '🔒';
      case 'announcement': return '📢';
      default: return '📝';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'feature': return '#10b981';
      case 'fix': return '#f59e0b';
      case 'security': return '#ef4444';
      case 'announcement': return '#3b82f6';
      default: return '#6b7280';
    }
  };

  return (
    <div className="changelog-container">
      <div className="changelog-header">
        <h1>📋 ALLACCESS SYSTEM v2.0 Updates</h1>
        <p>Stay updated with the latest features, fixes, and announcements</p>
      </div>

      <div className="changelog-timeline">
        {currentItems.map((update) => (
          <div key={update.id} className="timeline-item">
            <div className="timeline-marker" style={{ borderColor: getTypeColor(update.type) }}>
              {getTypeIcon(update.type)}
            </div>
            <div className="timeline-content">
              <div className="update-header">
                <span 
                  className="update-type" 
                  style={{ backgroundColor: getTypeColor(update.type) }}
                >
                  {update.type.toUpperCase()}
                </span>
                <span className="update-version">{update.version}</span>
                <span className="update-date">{update.date}</span>
              </div>
              
              <h3 className="update-title">{update.title}</h3>
              <p className="update-description">{update.description}</p>
              
              <div className="changes-list">
                <ul>
                  {update.changes.map((change, idx) => (
                    <li key={idx}>{change}</li>
                  ))}
                </ul>
              </div>
              
              <div className="update-footer">
                <span className="update-author">By: {update.author}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="pagination">
        <button 
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="pagination-btn"
        >
          Previous
        </button>
        
        <span className="page-info">
          Page {currentPage} of {totalPages}
        </span>
        
        <button 
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="pagination-btn"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ChangelogPage;